import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withViewTransitions, withInMemoryScrolling } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAnalytics, provideAnalytics } from '@angular/fire/analytics';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { initializeAppCheck, ReCaptchaV3Provider, provideAppCheck } from '@angular/fire/app-check';
import { environment } from '../environments/environment';
import { GlobalErrorHandler } from './services/global-error-handler';

// Create providers array with conditional App Check
const providers: any[] = [
  { provide: ErrorHandler, useClass: GlobalErrorHandler },
  provideZoneChangeDetection({ eventCoalescing: true }),
  provideRouter(
    routes,
    withViewTransitions(),
    withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
  ),
  provideFirebaseApp(() => initializeApp(environment.firebase)),
];

if (environment.appCheck) {
  if (!environment.production) {
    (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  const appCheckConfig = environment.appCheck as {
    recaptchaSiteKey: string;
    isTokenAutoRefreshEnabled: boolean;
  };
  providers.push(
    provideAppCheck(() =>
      initializeAppCheck(undefined, {
        provider: new ReCaptchaV3Provider(appCheckConfig.recaptchaSiteKey),
        isTokenAutoRefreshEnabled: appCheckConfig.isTokenAutoRefreshEnabled,
      }),
    ),
  );
}

// Add remaining providers
providers.push(
  provideAnalytics(() => getAnalytics()),
  provideAuth(() => getAuth()),
  provideFirestore(() => getFirestore()),
  provideFunctions(() => getFunctions(undefined, 'us-central1')),
  provideStorage(() => getStorage()),
  provideAnimations(),
);

export const appConfig: ApplicationConfig = {
  providers,
};
